import { AxiosResponse } from "axios";

import { DAO_SESHAT } from "@/api/DAO";
import { DOCUMENT_URL } from "@/api/URL-constants";

import { DocumentToUpdate } from "@/models/api/document.model";

const update = (payload: DocumentToUpdate): Promise<AxiosResponse> => {
  return DAO_SESHAT().put(DOCUMENT_URL, payload);
};

export { update };
